import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm$stock$stock_type, _vm$stock, _vm$stock2, _vm$stock3, _vm$stock4, _vm$stock5, _vm$selectedWarehouse, _vm$stock$wine;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    class: [_vm.mode == "popin" ? "stockPopin" : "stockPage"]
  }, [_vm.isForbiddenToAccessPage ? [_c("Error", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      error: {
        title: "Stock details not available",
        descriptionHtml: "It seems that you can't acces to this stock details page.<br /> Please contact an administrator for more information if you need help to fix this issue.",
        linkTitle: "Go back",
        link: "adminOrderList"
      }
    }
  })] : [_c("div", {
    staticClass: "container-centered small"
  }, [_vm.isClosedStock ? _c("div", {
    staticClass: "text-smaller text-italic text-red mb-4"
  }, [_vm._v(" This stock has been closed, potentially merged with a stock with same settings ")]) : _vm._e(), _c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_vm.$whitelabel.isAllowedToAccessPurchaseOrder ? _c("div", {
    staticClass: "btn-toggle-container"
  }, [!_vm.stock.id_stock && !((_vm$stock$stock_type = _vm.stock.stock_type) !== null && _vm$stock$stock_type !== void 0 && _vm$stock$stock_type.length) > 0 ? _c("div", {
    staticClass: "stock-title"
  }, [_vm._v(" Please select a stock type below ")]) : _vm._e(), _c(VBtnToggle, {
    class: [!_vm.isAdding ? "pointer-events-none" : ""],
    model: {
      value: _vm.stock.stock_type,
      callback: function callback($$v) {
        _vm.$set(_vm.stock, "stock_type", $$v);
      },
      expression: "stock.stock_type"
    }
  }, [_c(VBtn, {
    staticClass: "btn-toggle-stock flex-grow-1",
    attrs: {
      value: "stock",
      disabled: _vm.stock.id_stock && _vm.stock.stock_type && _vm.stock.stock_type.toLowerCase() !== "stock",
      "data-cy": "stock-type-stock-btn"
    },
    on: {
      click: function click($event) {
        return _vm.changeTypeStock("stock");
      }
    }
  }, [_c("i", {
    staticClass: "fas fa-boxes px-2"
  }), _vm._v(" Warehouse ")]), _c(VBtn, {
    staticClass: "btn-toggle-stock flex-shrink-1",
    attrs: {
      value: "consignment",
      disabled: _vm.stock.id_stock && _vm.stock.stock_type && _vm.stock.stock_type.toLowerCase() !== "consignment",
      "data-cy": "stock-type-direct-winery-btn"
    },
    on: {
      click: function click($event) {
        return _vm.changeTypeStock("consignment");
      }
    }
  }, [_c("i", {
    staticClass: "fas fa-dungeon px-2"
  }), _vm._v(" Direct Producer ")])], 1)], 1) : _vm._e(), !!_vm.stock.stock_type ? [_c("div", [_c("div", {
    staticClass: "flex gap-2 items-baseline"
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      disabled: !_vm.isAdding,
      items: _vm.wines,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "display_name",
      "item-value": "id_wine",
      label: "Choose the product",
      placeholder: "Type a product name, domain name, vintage....",
      "return-object": "",
      rules: [_vm.formRules.mustSelectValue],
      filter: _vm.filterVAutocomplete,
      "hide-details": "auto",
      "data-cy": "stock-wine-input"
    },
    on: {
      change: function change($event) {
        return _vm.chooseWine();
      }
    },
    model: {
      value: _vm.stock.wine,
      callback: function callback($$v) {
        _vm.$set(_vm.stock, "wine", $$v);
      },
      expression: "stock.wine"
    }
  }), _vm.stock.wine.id_wine && _vm.canAccessSupplierPrices ? _c(VBadge, {
    attrs: {
      color: _vm.wineSupplierPricesCount > 0 ? "green" : "red lighten-1",
      content: _vm.wineSupplierPricesCount ? _vm.wineSupplierPricesCount : "0",
      overlap: "",
      "offset-x": "20",
      "offset-y": "20"
    }
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary --small",
    attrs: {
      rounded: true,
      disabled: !_vm.stock.wine.id_wine
    },
    on: {
      click: function click($event) {
        return _vm.openSupplierPrices();
      }
    }
  }, [_c("i", {
    staticClass: "fas fa-search-dollar mr-1"
  }), _vm._v(" Supplier prices ")])], 1) : _vm._e()], 1), _vm.wineSupplierPricesCount === 0 ? _c("p", {
    staticClass: "errorLabel text-caption"
  }, [_vm._v(" You must add at least one supplier price for this wine before " + _vm._s(_vm.isAdding ? "creating" : "saving") + " the stock. ")]) : _vm._e()]), _vm.mode == "popin" && _vm.stock.wine != null ? _c("label", [_vm._v(_vm._s(_vm.stock.wine.displayName))]) : _vm._e(), _vm.stock.wine != null && !_vm.isAdding ? _c("div", {
    staticClass: "text-left text-smaller-2"
  }, [_c("router-link", {
    staticClass: "router-link",
    attrs: {
      to: _vm.goToProduct(_vm.stock.wine)
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-external-link-alt",
    staticStyle: {
      top: "-1px"
    },
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Product details ")], 1)], 1) : _vm._e(), _c("div", {
    staticClass: "flex gap-3"
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      readonly: !_vm.isAdding,
      type: "number",
      label: "Quantity available, number of bottles",
      placeholder: "Number of bottles",
      rules: _vm.isAdding ? [_vm.formRules.mustBeIntNotNegative] : [],
      "hide-details": "auto",
      "data-cy": "stock-quantity-input"
    },
    model: {
      value: _vm.stock.quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.stock, "quantity", $$v);
      },
      expression: "stock.quantity"
    }
  }), _vm.isNewTransferAvailable ? [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.openNewStockTransfer();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Domestic transfer ")], 1), _vm.newStockTransferModal.shown ? _c("StockTransferDomesticNewPartFormModal", {
    ref: "newStockTransferForm",
    attrs: {
      loggedUserData: _vm.loggedUserData,
      stockId: (_vm$stock = _vm.stock) === null || _vm$stock === void 0 ? void 0 : _vm$stock.id_stock,
      fromWarehouseId: (_vm$stock2 = _vm.stock) === null || _vm$stock2 === void 0 ? void 0 : _vm$stock2.id_warehouse,
      quantityAvailable: (_vm$stock3 = _vm.stock) === null || _vm$stock3 === void 0 ? void 0 : _vm$stock3.quantity,
      wineName: (_vm$stock4 = _vm.stock) === null || _vm$stock4 === void 0 || (_vm$stock4 = _vm$stock4.wine) === null || _vm$stock4 === void 0 ? void 0 : _vm$stock4.display_name
    },
    on: {
      entityCreated: _vm.getStock,
      closed: function closed($event) {
        return _vm.closeNewStockTransfer();
      }
    }
  }) : _vm._e()] : _vm._e(), _vm.isSplitAvailable && _vm.canManage ? [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.openSplitStock();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Split/Reserve stock ")], 1), _vm.splitStockModal.shown ? _c("StockSplitFormModal", {
    ref: "splitStockForm",
    attrs: {
      stock: _vm.stock,
      countries: _vm.countries
    },
    on: {
      entityCreated: _vm.getStock,
      closed: function closed($event) {
        return _vm.closeSplitStock();
      }
    }
  }) : _vm._e()] : _vm._e()], 2), _vm.isAdding ? [_vm.stock.stock_type.toLowerCase() === "stock" ? _c(VAutocomplete, {
    attrs: {
      disabled: _vm.compatibleOrderItems.length === 0,
      label: "Transfer from order",
      items: _vm.compatibleOrderItems,
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      "item-text": "text",
      "item-value": "orderId",
      "hide-details": "auto"
    },
    model: {
      value: _vm.fromOrderId,
      callback: function callback($$v) {
        _vm.fromOrderId = $$v;
      },
      expression: "fromOrderId"
    }
  }) : _vm._e(), _vm.stock.stock_type.toLowerCase() === "stock" ? _c(VTextField, {
    attrs: {
      type: "number",
      label: "Purchase unit price (€ excl.vat)",
      placeholder: "Especially if it's different than product cogs",
      rules: [_vm.formRules.mustBeGreaterThan0OrEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.stock.firstAddPartPurchasePriceUnitEuroExVat,
      callback: function callback($$v) {
        _vm.$set(_vm.stock, "firstAddPartPurchasePriceUnitEuroExVat", $$v);
      },
      expression: "stock.firstAddPartPurchasePriceUnitEuroExVat"
    }
  }) : _vm._e(), _c(VTextarea, {
    staticClass: "required",
    attrs: {
      label: "Manual creation reason(s)",
      rules: [_vm.formRules.mustNotBeEmpty],
      rows: "3",
      "hide-details": "auto"
    },
    model: {
      value: _vm.creationComment,
      callback: function callback($$v) {
        _vm.creationComment = $$v;
      },
      expression: "creationComment"
    }
  })] : _vm._e(), !_vm.isAdding ? _c("div", {
    staticClass: "text-left text-smaller"
  }, [_vm.stock.parts.length > 0 ? [_c("div", {
    staticClass: "text-smaller text-underline"
  }, [_vm._v("Composed by")]), _c("div", _vm._l(_vm.stock.parts, function (part, index) {
    var _part$fromPoData, _part$fromOrderData, _part$fromOrderData$i, _part$fromPoData2, _part$fromOrderData2, _part$fromOrderData3, _part$fromPoData3;
    return _c("div", {
      key: "part-" + index
    }, [_c("div", {
      class: index > 0 ? ["mt-1"] : []
    }, [_vm._v(" " + _vm._s(part.quantityAvailable) + " b. "), _c("span", {
      staticClass: "text-smaller"
    }, [_vm._v(" from "), ((_part$fromPoData = part.fromPoData) === null || _part$fromPoData === void 0 ? void 0 : _part$fromPoData.id) > 0 ? [_c("router-link", {
      staticClass: "router-link",
      attrs: {
        to: _vm.goToPurchaseOrder(part.fromPoData.id),
        target: "_blank"
      }
    }, [_vm._v(" " + _vm._s(part.fromPoData.reference ? "Po:".concat(part.fromPoData.reference) : "Po#".concat(part.fromPoData.id)) + " ")]), part.fromPoData.actualDeliveryDate ? _c("span", [_vm._v(" , Receipt:" + _vm._s(_vm._f("formatDate")(part.fromPoData.actualDeliveryDate)) + " ")]) : _vm._e()] : _vm._e(), ((_part$fromOrderData = part.fromOrderData) === null || _part$fromOrderData === void 0 ? void 0 : _part$fromOrderData.id) > 0 ? [_c("router-link", {
      staticClass: "router-link",
      attrs: {
        to: _vm.goToOrder(part.fromOrderData.id),
        target: "_blank"
      }
    }, [_vm._v(" " + _vm._s((_part$fromOrderData$i = part.fromOrderData.invoiceNumberLabel) !== null && _part$fromOrderData$i !== void 0 ? _part$fromOrderData$i : part.fromOrderData.referenceOrder.shorterReference()) + " ")]), part.fromOrderData.deliveryDate ? _c("span", [_vm._v(" , Delivered: " + _vm._s(_vm._f("formatDate")(part.fromOrderData.deliveryDate)) + " ")]) : _vm._e()] : _vm._e(), part.fromFirstInit ? [_vm._v("first initialisation")] : _vm._e(), !(((_part$fromPoData2 = part.fromPoData) === null || _part$fromPoData2 === void 0 ? void 0 : _part$fromPoData2.id) > 0) && !(((_part$fromOrderData2 = part.fromOrderData) === null || _part$fromOrderData2 === void 0 ? void 0 : _part$fromOrderData2.id) > 0) && !part.fromFirstInit ? [_vm._v(" manual adjustment ")] : _vm._e()], 2), !((_part$fromOrderData3 = part.fromOrderData) !== null && _part$fromOrderData3 !== void 0 && _part$fromOrderData3.deliveryDate) && !((_part$fromPoData3 = part.fromPoData) !== null && _part$fromPoData3 !== void 0 && _part$fromPoData3.actualDeliveryDate) ? _c("span", {
      staticClass: "text-smaller"
    }, [_vm._v(" , " + _vm._s(_vm._f("formatDate_string")(part.creationDate)) + " ")]) : _vm._e(), !_vm.isClosedStock && part.status === _vm.STOCK_PART.STATUS.PRESELL.id ? _c("span", {
      staticClass: "badge warning --small --padding ml-2"
    }, [_vm._v(" #PRE-ARRIVAL ")]) : _vm._e(), _vm.canManage ? _c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary ml-2",
      attrs: {
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.startEditPartQuantity(part);
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-pen mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Edit ")], 1) : _vm._e()], 1)]);
  }), 0)] : _vm._e(), !_vm.isClosedStock && _vm.canManage ? _c("div", {
    staticClass: "mt-1"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.openNewStockPart
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add new stock part ")], 1)], 1) : _vm._e(), _vm.editPartModal.shown ? _c("StockPartFormModal", {
    ref: "stockPartForm",
    attrs: {
      id: _vm.editPartModal.partId,
      stockId: (_vm$stock5 = _vm.stock) === null || _vm$stock5 === void 0 ? void 0 : _vm$stock5.id_stock
    },
    on: {
      entityUpdated: _vm.getStock,
      entityCreated: _vm.getStock,
      closed: _vm.closePartModal
    }
  }) : _vm._e()], 2) : _vm._e(), !_vm.isAdding ? [!!_vm.stock.quantity_committed ? [_c(VTextField, {
    attrs: {
      type: "number",
      label: "Quantity committed",
      placeholder: "Number of bottles",
      "hide-details": "auto",
      disabled: ""
    },
    model: {
      value: _vm.stock.quantity_committed,
      callback: function callback($$v) {
        _vm.$set(_vm.stock, "quantity_committed", $$v);
      },
      expression: "stock.quantity_committed"
    }
  }), _c("div", {
    staticClass: "text-left"
  }, [!!_vm.stock.quantity_committed ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.showCommittedDetails();
      }
    }
  }, [_vm._v(" details of committed stocks ")]) : _vm._e()], 1)] : _c("div", {
    staticClass: "text-left text-smaller text-italic"
  }, [_vm._v("0 b. committed")])] : _vm._e(), !_vm.isAdding ? _c("div", {
    staticClass: "text-bold text-left mt-default"
  }, [_vm._v("Settings")]) : _vm._e(), _vm.stock.stock_type == "consignment" ? _c(VSelect, {
    attrs: {
      label: "Storage location",
      items: _vm.consignmentAvailableStorageLocations,
      disabled: _vm.stock.quantity_committed > 0,
      readonly: _vm.isClosedStock || !_vm.canManage,
      "hide-details": "auto"
    },
    model: {
      value: _vm.stock.id_address_consignment_storage,
      callback: function callback($$v) {
        _vm.$set(_vm.stock, "id_address_consignment_storage", $$v);
      },
      expression: "stock.id_address_consignment_storage"
    }
  }) : _vm._e(), _vm.visible_warehouse ? [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Reference in warehouse",
      placeholder: "DRB-01",
      "hide-details": "auto",
      rules: [_vm.customRules.mustBeReferenceWarehouse],
      readonly: _vm.isClosedStock || !_vm.canManage,
      "data-cy": "stock-reference-warehouse"
    },
    model: {
      value: _vm.stock.reference_warehouse,
      callback: function callback($$v) {
        _vm.$set(_vm.stock, "reference_warehouse", $$v);
      },
      expression: "stock.reference_warehouse"
    }
  }), _vm.loading.stockLoaded && _vm.loading.warehouseLoaded ? _c("WarehouseSelectComponent", {
    ref: "warehouseSelect",
    attrs: {
      warehouses: _vm.listWarehouses,
      selected: (_vm$selectedWarehouse = _vm.selectedWarehouse) === null || _vm$selectedWarehouse === void 0 ? void 0 : _vm$selectedWarehouse.id_warehouse,
      required: true,
      disabled: _vm.isClosedStock || !_vm.canManage || !_vm.canManageWarehouseOfStock,
      rules: _vm.rulesForWarehouseSelectComponent,
      "data-cy": "stock-warehouses-input"
    },
    on: {
      changeWarehouse: _vm.changeWarehouse,
      fetchWarehouses: _vm.fetchWarhousesWhenItemsUpdated
    }
  }) : _vm._e()] : _vm._e(), _vm.visible_country ? [_c(VSelect, {
    staticClass: "required",
    attrs: {
      chips: "",
      items: _vm.countries,
      label: "Intended countries",
      "item-text": "printable_name",
      "item-value": "id_country",
      placeholder: "France",
      multiple: "",
      rules: [_vm.formRules.mustSelectValue],
      readonly: _vm.isClosedStock || !_vm.canManage,
      "hide-details": "auto",
      "data-cy": "stock-intended-countrie-input"
    },
    scopedSlots: _vm._u([{
      key: "prepend-item",
      fn: function fn() {
        return [_c(VListItem, {
          attrs: {
            ripple: "",
            "data-cy": "stock-intended-countrie-select-all-btn"
          },
          on: {
            click: _vm.changeIntendedCountries
          }
        }, [_c(VListItemAction, [_c(VIcon, [_vm._v(" " + _vm._s(_vm.getIconForIntendedCountriesCloser) + " ")])], 1), _c(VListItemContent, [_c(VListItemTitle, [_vm._v("Select All")])], 1)], 1), false ? [_c(VListItem, {
          attrs: {
            ripple: "",
            disabled: ""
          },
          on: {
            click: _vm.changeIntendedCountries
          }
        }, [_c(VListItemContent, [_c(VListItemTitle, {
          staticClass: "text-italic"
        }, [_vm._v(" Europe (coming soon) ")])], 1)], 1), _c(VListItem, {
          attrs: {
            ripple: "",
            disabled: ""
          },
          on: {
            click: _vm.changeIntendedCountries
          }
        }, [_c(VListItemContent, [_c(VListItemTitle, {
          staticClass: "text-italic"
        }, [_vm._v(" North America (coming soon) ")])], 1)], 1), _c(VListItem, {
          attrs: {
            ripple: "",
            disabled: ""
          },
          on: {
            click: _vm.changeIntendedCountries
          }
        }, [_c(VListItemContent, [_c(VListItemTitle, {
          staticClass: "text-italic"
        }, [_vm._v(" Asia (coming soon) ")])], 1)], 1)] : _vm._e(), _c(VDivider, {
          staticClass: "mt-2"
        })];
      },
      proxy: true
    }], null, false, 1932933663),
    model: {
      value: _vm.stock.country_ids,
      callback: function callback($$v) {
        _vm.$set(_vm.stock, "country_ids", $$v);
      },
      expression: "stock.country_ids"
    }
  }), _vm.isIntendedCountriesDifferentAsWarehouseDefault && _vm.canManage ? _c("div", {
    staticClass: "text-left text-smaller-2 text-warning"
  }, [_vm._v(" There is discrepedencies between warehouse default intended countries, and this stock's intended countries "), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary ml-3",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.defineIntededCountriesAsDefault
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-sync mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Synchronize countries ")], 1)], 1) : _vm._e()] : _vm._e(), _c(VSelect, {
    staticClass: "required",
    attrs: {
      label: "Consolidation for order (warehouse departure)",
      items: _vm.listWarehousesForDefaultDeparture,
      readonly: _vm.isClosedStock || !_vm.canManage || !_vm.canManageWarehouseOfStock,
      "hide-no-data": "",
      "hide-details": "auto",
      "item-text": "name",
      "item-value": "id_warehouse"
    },
    model: {
      value: _vm.stock.warehouse_default_departure.id_warehouse,
      callback: function callback($$v) {
        _vm.$set(_vm.stock.warehouse_default_departure, "id_warehouse", $$v);
      },
      expression: "stock.warehouse_default_departure.id_warehouse"
    }
  }), _c("StockReservation", {
    ref: "reservation",
    attrs: {
      form: {
        stockReservationType: _vm.stock.reservation_type,
        stockReservationUserId: _vm.stock.reservation_user_id,
        stockReservationConsultantId: _vm.stock.reservation_consultant_id
      },
      isPrefixedWithDefault: false,
      reservedForMessage: _vm.stock.stock_type.toLowerCase() === "stock" && (!!_vm.stock.reservation_user_id || !!_vm.stock.reservation_consultant_id) ? "Please be cautious that the intended countries are compatibles with this reservation" : "",
      readonly: _vm.isClosedStock || !_vm.canManage
    },
    on: {
      change: _vm.updateStockReservation,
      mounted: _vm.firstMountStockReservation
    }
  }), _c("div", [_c(VCheckbox, {
    staticClass: "mt-2",
    attrs: {
      label: "Has low stock alert",
      "hide-details": "auto",
      readonly: _vm.isClosedStock || !_vm.canManage
    },
    model: {
      value: _vm.stock.hasLowStockAlert,
      callback: function callback($$v) {
        _vm.$set(_vm.stock, "hasLowStockAlert", $$v);
      },
      expression: "stock.hasLowStockAlert"
    }
  }), _vm.stock.hasLowStockAlert ? _c(VTextField, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      type: "text",
      prefix: "Trigger alert:",
      placeholder: "Number of bottles (60)",
      rules: [_vm.formRules.mustBeIntNotNegative],
      "hide-details": "auto",
      readonly: _vm.isClosedStock || !_vm.canManage
    },
    on: {
      keypress: _vm.filterIntegerKey
    },
    model: {
      value: _vm.stock.lowStockAlertQuantity,
      callback: function callback($$v) {
        _vm.$set(_vm.stock, "lowStockAlertQuantity", $$v);
      },
      expression: "stock.lowStockAlertQuantity"
    }
  }) : _vm._e()], 1)] : _vm._e()], 2), _vm.loaded && _vm.mode != "popin" && _vm.canManage && !!_vm.stock.stock_type ? _c("div", {
    staticClass: "button-end-page-container",
    attrs: {
      id: "buttonsUpdate"
    }
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary --small",
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.cancel();
      }
    }
  }, [_vm._v(" Exit ")]), _vm.stock.id_stock != null && !_vm.isClosedStock ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      loading: _vm.closingStock.isPending,
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.showConfirmDelete();
      }
    }
  }, [_vm._v(" Close stock ")]) : _vm._e(), _vm.isAdding ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      disabled: !_vm.isStockValid || _vm.isAnyActionInProgress,
      loading: _vm.creatingStock.isPending,
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.createNewStock();
      }
    }
  }, [_vm._v(" Create ")]) : !_vm.isClosedStock ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      disabled: !_vm.isStockValid || _vm.isAnyActionInProgress,
      loading: _vm.updatingSettings.isPending,
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.updateStockSettings();
      }
    }
  }, [_vm._v(" Save settings ")]) : _vm._e()], 1) : _vm.loaded && _vm.mode == "popin" && _vm.canManage ? _c("div", {
    staticClass: "bloc-buttons-popin"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.cancel();
      }
    }
  }, [_vm._v("Cancel")]), _vm.isAdding ? _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      disabled: !_vm.isStockValid || _vm.isAnyActionInProgress,
      loading: _vm.creatingStock.isPending,
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.createNewStock();
      }
    }
  }, [_vm._v(" Create ")]) : !_vm.isClosedStock ? _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      disabled: !_vm.isStockValid || _vm.isAnyActionInProgress,
      loading: _vm.creatingStock.isPending,
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.updateStockSettings();
      }
    }
  }, [_vm._v(" Save settings ")]) : _vm._e()], 1) : _vm._e(), _vm.isClosedStock ? _c("div", {
    staticClass: "text-smaller text-italic text-red mt-default"
  }, [_vm._v(" This stock has been closed, potentially merged with a stock with same settings ")]) : _vm._e()], 1), _c("confirm", {
    ref: "confirm"
  }), !_vm.isAdding && _vm.canManage && _vm.stock.quantity_committed > 0 ? _c("StockCommittedDialog", {
    attrs: {
      idStock: _vm.stock.id_stock
    },
    on: {
      close: _vm.closeCommittedDetails
    },
    model: {
      value: _vm.stockCommittedShown,
      callback: function callback($$v) {
        _vm.stockCommittedShown = $$v;
      },
      expression: "stockCommittedShown"
    }
  }) : _vm._e(), _vm.canAccessSupplierPrices && _vm.stock.wine.id_wine ? _c("WineSupplierPriceModal", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isWineSupplierPriceModalShown,
      expression: "isWineSupplierPriceModalShown"
    }],
    ref: "wineSupplierPriceModal",
    attrs: {
      loggedUserData: _vm.loggedUserData,
      wineId: +((_vm$stock$wine = _vm.stock.wine) === null || _vm$stock$wine === void 0 ? void 0 : _vm$stock$wine.id_wine)
    },
    on: {
      closed: _vm.closeSupplierPrices,
      fetched: function fetched($event) {
        _vm.wineSupplierPricesCount = $event;
      }
    }
  }) : _vm._e()], _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };